import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/pages/home/data";

export default function ProcessSection() {
  return (
    <section id="process" className="scroll-mt-20 w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="曝光流程"
          title="从提交到曝光，四步走完全程"
          description="不少投稿人因为不清楚流程而反复补充材料、延误曝光。我们把每个阶段要做的事、由谁来做、需要多久，都拆开说清楚。"
        />

        <ol className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {processSteps.map((step, i) => (
            <li key={step.index} className="relative">
              <div className="h-full p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 flex flex-col">
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
                    <i className={step.icon} aria-hidden="true"></i>
                  </span>
                  <span className="font-heading text-3xl font-bold text-background-400">
                    {step.index}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                  {step.desc}
                </p>
              </div>
              {i < processSteps.length - 1 && (
                <span
                  aria-hidden="true"
                  className="hidden lg:flex absolute top-1/2 -right-4 z-10 w-8 h-8 items-center justify-center text-primary-400"
                >
                  <i className="ri-arrow-right-line"></i>
                </span>
              )}
            </li>
          ))}
        </ol>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 p-5 rounded-lg bg-accent-50 border border-accent-200">
          <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950 text-xl">
            <i className="ri-lightbulb-flash-line" aria-hidden="true"></i>
          </span>
          <p className="text-sm leading-relaxed text-foreground-700">
            <strong className="font-semibold text-foreground-950">小提示：</strong>
            提交时请尽量一次性提供完整材料。初审阶段若发现证据缺口，我们会通过查询编号标注“待补充证据”，补充后可继续沿用原有排队顺序，无需重新投稿。
          </p>
        </div>
      </div>
    </section>
  );
}